'use strict';
/*
* Novicell master
* Use this file to call functions in other files, on document ready, window.resize etc.
*/

var novicell = novicell || {};
var dgv = dgv || {};

// Document ready
document.addEventListener('DOMContentLoaded', function(){
    svg4everybody(); // Fix SVG spritemap in IE/Edge

    // DGV functions
    dgv.cookieInfo.init();
    dgv.carousels.init();
    dgv.scroller.init();
    dgv.imageParallax.init();
    dgv.mobileMenu.init();
    dgv.nextSeasonMenuSlider.init();
    dgv.newsletterSelect.init();
    dgv.conceptVideo.init();

    // var job_container = document.getElementById('js-job-container');
    // if ( job_container ) {
    // 	dgv.accordions.init(job_container);
    // }

    var dropdown_btn = document.getElementById('js-dropdown-btn');

    if ( dropdown_btn ) {
        dropdown_btn.addEventListener('click', function(e) {
            e.stopPropagation();

            if ( window.innerWidth < 992 ) {
                if ( !dropdown_btn.classList.contains('show') ) {
                    dropdown_btn.classList.add('show');
                } else {
                    dropdown_btn.classList.remove('show');
                }
            }
        });
    }

    // Remove SuperPWA
    navigator.serviceWorker.getRegistrations().then(function(registrations) {
        for(let registration of registrations) {
            registration.unregister()
        } })
});

